import React, { useEffect } from 'react';
import { Hero } from './components/Hero';
import { PainSection } from './components/PainSection';
import { AgitateSection } from './components/AgitateSection';
import { QuestionsSection } from './components/QuestionsSection';
import { MistakesSection } from './components/MistakesSection';
import { SystemRevealSection } from './components/SystemRevealSection';
import { ProblemFinderSection } from './components/ProblemFinderSection';
import { IncludesSection } from './components/IncludesSection';
import { EbookCarouselSection } from './components/EbookCarouselSection';
import { MidPageCta } from './components/MidPageCta';
import { BonusesSection } from './components/BonusesSection';
import { OfferSection } from './components/OfferSection';
import { ComparisonSection } from './components/ComparisonSection';
import { IndependenceSection } from './components/IndependenceSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { FaqSection } from './components/FaqSection';
import { FinalOfferSection } from './components/FinalOfferSection';
import { Footer } from './components/Footer';
import { StickyCta } from './components/StickyCta';
import { initMetaPixel } from './utils/metaPixel';
export function App() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <div className="w-full max-w-full bg-abyss-950 pb-24 font-sans text-body [overflow-x:clip] lg:pb-0" data-id="element-0" data-mp="6801qozk67w">
      <Hero data-id="element-1" data-mp="2zm4zaoz9bl3x" />

      <main data-id="element-2" data-mp="2zmem63p09c5e">
        <PainSection data-id="element-3" data-mp="2zmwguvw0rib7" />
        <AgitateSection data-id="element-4" data-mp="2znfyebhrc4op" />
        <QuestionsSection data-id="element-5" data-mp="33m5ck6amdq9e" />
        <MistakesSection data-id="element-6" data-mp="33nggc642ey0i" />
        <SystemRevealSection data-id="element-7" data-mp="33oriy2lrxzq1" />
        <ProblemFinderSection data-id="element-8" data-mp="38m1elzzrb7mb" />
        <IncludesSection data-id="element-9" data-mp="38kqau06b9zv7" />
        <EbookCarouselSection data-id="element-10" data-mp="38kgmeh0x00rm" />
        <MidPageCta data-id="element-11" data-mp="3dkus3sf1mymh" />
        <BonusesSection data-id="element-12" data-mp="3dl4n5uey3vz1" />
        <OfferSection data-id="element-13" data-mp="3dlnwimqj5c1g" />
        <ComparisonSection data-id="element-14" data-mp="3dirtwl3qlz6o" />
        <IndependenceSection data-id="element-15" data-mp="nvsup6ui4rx0" />
        <GuaranteeSection data-id="element-16" data-mp="nuhhyhj2w9tr" />
        <FaqSection data-id="element-17" data-mp="nvas7sh8xhgn" />
        <FinalOfferSection data-id="element-18" data-mp="nxwupdpa56s0" />
      </main>

      <Footer data-id="element-19" data-mp="stkmm0v5ce17" />
      <StickyCta data-id="element-20" data-mp="stc7017n2umb" />
    </div>;
}